/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * GO Reserve 乗務レポートのレコード(乗車１回分)
 * @export
 * @interface ReserveTripsReportRow
 */
export interface ReserveTripsReportRow {
    /**
     * 乗務日
     * @type {number}
     * @memberof ReserveTripsReportRow
     */
    shiftDate?: number;
    /**
     * 営業所ID
     * @type {number}
     * @memberof ReserveTripsReportRow
     */
    officeId?: number;
    /**
     * 営業所名称
     * @type {string}
     * @memberof ReserveTripsReportRow
     */
    officeName?: string;
    /**
     * 乗務員ID
     * @type {number}
     * @memberof ReserveTripsReportRow
     */
    driverId?: number;
    /**
     * 乗務員名
     * @type {string}
     * @memberof ReserveTripsReportRow
     */
    driverName?: string;
    /**
     * 乗務員番号
     * @type {string}
     * @memberof ReserveTripsReportRow
     */
    driverCode?: string;
    /**
     * 複数のログイン/ログアウトを乗務単位にまとめるためのID
     * @type {string}
     * @memberof ReserveTripsReportRow
     */
    shiftId?: string;
    /**
     * 乗務時間
     * @type {number}
     * @memberof ReserveTripsReportRow
     */
    shiftLenMin?: number;
    /**
     * 要指導
     * @type {string}
     * @memberof ReserveTripsReportRow
     */
    needGuidance?: string;
    /**
     * 空車開始時刻(UTC, フォーマット '2023-05-02T04:13:18Z')
     * @type {string}
     * @memberof ReserveTripsReportRow
     */
    unladenStartTs?: string;
    /**
     * 空車開始場所
     * @type {string}
     * @memberof ReserveTripsReportRow
     */
    unladenStartCity?: string;
    /**
     * 乗車時刻
     * @type {string}
     * @memberof ReserveTripsReportRow
     */
    boardingTs?: string;
    /**
     * 乗車場所
     * @type {string}
     * @memberof ReserveTripsReportRow
     */
    boardingCity?: string;
    /**
     * 空車時間(秒)
     * @type {number}
     * @memberof ReserveTripsReportRow
     */
    unladenSec?: number;
    /**
     * 配車一時停止時間(秒)
     * @type {number}
     * @memberof ReserveTripsReportRow
     */
    pauseCarRequestSec?: number;
    /**
     * 走行時間
     * @type {number}
     * @memberof ReserveTripsReportRow
     */
    handleTime?: number;
    /**
     * 乗車種別 (cruising/stand/go/tel/cancel_tel/homing/error)
     * @type {string}
     * @memberof ReserveTripsReportRow
     */
    boardingType?: string;
    /**
     * ナビ停止時間(秒)
     * @type {number}
     * @memberof ReserveTripsReportRow
     */
    naviOffSec?: number;
    /**
     * 離脱回数
     * @type {number}
     * @memberof ReserveTripsReportRow
     */
    deviationCount?: number;
    /**
     * キャンセル回数
     * @type {number}
     * @memberof ReserveTripsReportRow
     */
    goCancelCount?: number;
    /**
     * 下車時刻
     * @type {string}
     * @memberof ReserveTripsReportRow
     */
    deliverTs?: string;
    /**
     * 下車場所
     * @type {string}
     * @memberof ReserveTripsReportRow
     */
    deliverCity?: string;
    /**
     * ナビoffバツマーク
     * @type {number}
     * @memberof ReserveTripsReportRow
     */
    isHermesOff?: number;
    /**
     * Goキャンセルバツマーク
     * @type {number}
     * @memberof ReserveTripsReportRow
     */
    isGoCancel?: number;
    /**
     * 離脱バツマーク
     * @type {number}
     * @memberof ReserveTripsReportRow
     */
    isDeviation?: number;
    /**
     * unladen start coords
     * @type {object}
     * @memberof ReserveTripsReportRow
     */
    unladenStartLoc?: object;
    /**
     * deliver start coords
     * @type {object}
     * @memberof ReserveTripsReportRow
     */
    deliverStartLoc?: object;
    /**
     * trip session id
     * @type {string}
     * @memberof ReserveTripsReportRow
     */
    tripSessionId?: string;
    /**
     * ログイン(開局) 単位で発行されるID
     * @type {string}
     * @memberof ReserveTripsReportRow
     */
    loginSessionId?: string;
}

export function ReserveTripsReportRowFromJSON(json: any): ReserveTripsReportRow {
    return ReserveTripsReportRowFromJSONTyped(json, false);
}

export function ReserveTripsReportRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReserveTripsReportRow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'shiftDate': !exists(json, 'shift_date') ? undefined : json['shift_date'],
        'officeId': !exists(json, 'office_id') ? undefined : json['office_id'],
        'officeName': !exists(json, 'office_name') ? undefined : json['office_name'],
        'driverId': !exists(json, 'driver_id') ? undefined : json['driver_id'],
        'driverName': !exists(json, 'driver_name') ? undefined : json['driver_name'],
        'driverCode': !exists(json, 'driver_code') ? undefined : json['driver_code'],
        'shiftId': !exists(json, 'shift_id') ? undefined : json['shift_id'],
        'shiftLenMin': !exists(json, 'shift_len_min') ? undefined : json['shift_len_min'],
        'needGuidance': !exists(json, 'need_guidance') ? undefined : json['need_guidance'],
        'unladenStartTs': !exists(json, 'unladen_start_ts') ? undefined : json['unladen_start_ts'],
        'unladenStartCity': !exists(json, 'unladen_start_city') ? undefined : json['unladen_start_city'],
        'boardingTs': !exists(json, 'boarding_ts') ? undefined : json['boarding_ts'],
        'boardingCity': !exists(json, 'boarding_city') ? undefined : json['boarding_city'],
        'unladenSec': !exists(json, 'unladen_sec') ? undefined : json['unladen_sec'],
        'pauseCarRequestSec': !exists(json, 'pause_car_request_sec') ? undefined : json['pause_car_request_sec'],
        'handleTime': !exists(json, 'handle_time') ? undefined : json['handle_time'],
        'boardingType': !exists(json, 'boarding_type') ? undefined : json['boarding_type'],
        'naviOffSec': !exists(json, 'navi_off_sec') ? undefined : json['navi_off_sec'],
        'deviationCount': !exists(json, 'deviation_count') ? undefined : json['deviation_count'],
        'goCancelCount': !exists(json, 'go_cancel_count') ? undefined : json['go_cancel_count'],
        'deliverTs': !exists(json, 'deliver_ts') ? undefined : json['deliver_ts'],
        'deliverCity': !exists(json, 'deliver_city') ? undefined : json['deliver_city'],
        'isHermesOff': !exists(json, 'is_hermes_off') ? undefined : json['is_hermes_off'],
        'isGoCancel': !exists(json, 'is_go_cancel') ? undefined : json['is_go_cancel'],
        'isDeviation': !exists(json, 'is_deviation') ? undefined : json['is_deviation'],
        'unladenStartLoc': !exists(json, 'unladen_start_loc') ? undefined : json['unladen_start_loc'],
        'deliverStartLoc': !exists(json, 'deliver_start_loc') ? undefined : json['deliver_start_loc'],
        'tripSessionId': !exists(json, 'trip_session_id') ? undefined : json['trip_session_id'],
        'loginSessionId': !exists(json, 'login_session_id') ? undefined : json['login_session_id'],
    };
}

export function ReserveTripsReportRowToJSON(value?: ReserveTripsReportRow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'shift_date': value.shiftDate,
        'office_id': value.officeId,
        'office_name': value.officeName,
        'driver_id': value.driverId,
        'driver_name': value.driverName,
        'driver_code': value.driverCode,
        'shift_id': value.shiftId,
        'shift_len_min': value.shiftLenMin,
        'need_guidance': value.needGuidance,
        'unladen_start_ts': value.unladenStartTs,
        'unladen_start_city': value.unladenStartCity,
        'boarding_ts': value.boardingTs,
        'boarding_city': value.boardingCity,
        'unladen_sec': value.unladenSec,
        'pause_car_request_sec': value.pauseCarRequestSec,
        'handle_time': value.handleTime,
        'boarding_type': value.boardingType,
        'navi_off_sec': value.naviOffSec,
        'deviation_count': value.deviationCount,
        'go_cancel_count': value.goCancelCount,
        'deliver_ts': value.deliverTs,
        'deliver_city': value.deliverCity,
        'is_hermes_off': value.isHermesOff,
        'is_go_cancel': value.isGoCancel,
        'is_deviation': value.isDeviation,
        'unladen_start_loc': value.unladenStartLoc,
        'deliver_start_loc': value.deliverStartLoc,
        'trip_session_id': value.tripSessionId,
        'login_session_id': value.loginSessionId,
    };
}


